import classNames from "classnames";
import "./index.scss";
import CustomModal from "../CustomModal";
import { boolean } from "yup";
import { useState } from "react";
import CustomBadges from "../CustomBadges";

type Props = {
  imageUrl: string;
  onClick?: () => void;
  size?: "small" | "medium" | "large" | "x-large";
  hoverTitle?: string | null;
};

const ImageViewer = ({ imageUrl }: Props) => {
  const [zoomInImage, setZoomInImage] = useState<string>("");
  console.log(imageUrl);
  return (
    <>
      {imageUrl ? (
        <>
          <section id="imageViewer">
            <div
              className="imageViewer-container"
              onClick={() => setZoomInImage(imageUrl)}
            >
              <img src={imageUrl} />
            </div>
          </section>
          <CustomModal
            open={zoomInImage !== ""}
            onClose={() => setZoomInImage("")}
            width={"50rem"}
            maxHeight={"85vh"}
          >
            <div className="zoom-in-container">
              <img src={imageUrl} />
            </div>
          </CustomModal>
        </>
      ) : (
        <section id="imageViewer">
          <div className="imageViewer-container">
            <CustomBadges title={"تصویر بارگذاری نشده !"} type="danger" />
          </div>
        </section>
      )}
    </>
  );
};

export default ImageViewer;
